import { render, staticRenderFns } from "./SkillSearchTypeSelector.vue?vue&type=template&id=2716fe48&scoped=true&"
import script from "./SkillSearchTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./SkillSearchTypeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SkillSearchTypeSelector.vue?vue&type=style&index=0&id=2716fe48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2716fe48",
  null
  
)

export default component.exports